import PropTypes from 'prop-types';
import React from 'react';

import ArrowRight from '../../icons/arrowRight.svg';
import StyledLink from './link.style';

const Link = React.forwardRef(({ children, href, hasIcon = false, ...props }, ref) => {
  return (
    <StyledLink href={href} {...props} ref={ref}>
      {children}
      {hasIcon && <ArrowRight className="link__icon" />}
    </StyledLink>
  );
});

Link.propTypes = {
  /** Label of link */
  children: PropTypes.node,
  /** Link target */
  href: PropTypes.string,
  hasIcon: PropTypes.bool
};

export default Link;
